import { FC } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';

import { CopyrightFeeTooltip } from '../components/CopyrightFeeTooltip';
import { Image } from '../components/Image';
import { PriceRow } from '../components/PriceRow';
import { ORDER_CART_ENTRY_ID, ORDER_CART_TEST_ID } from '../constants';
import { ImageData, Price } from '../model';
import { CellDetailSecondary, CellTitle, GiftBadge, GiftEntryListItem, Separator } from './entries.styles';

type GiftEntryProps = {
    image: ImageData;
    name: string;
    variantOptions: string;
    price: Price;
    copyrightFee: Price;
};

export const GiftEntry: FC<GiftEntryProps> = ({ name, image, price, copyrightFee, variantOptions }) => {
    const { t } = useTranslations();

    return (
        <GiftEntryListItem data-test={ORDER_CART_ENTRY_ID.GIFT} aria-label={name}>
            <Image url={image.url} alt={image.alt} />
            <CellTitle data-test={ORDER_CART_TEST_ID.ENTRY_TITLE_GIFT}>{name}</CellTitle>
            <CellDetailSecondary>{variantOptions}</CellDetailSecondary>
            <GiftBadge>{t['order_cart.entry_gift.badge']}</GiftBadge>

            <Separator />

            <PriceRow
                term={t['order_cart.entry_gift.price_label']}
                price={price}
                dataTest={ORDER_CART_TEST_ID.PRICE_GIFT}
            />
            <PriceRow
                term={<CopyrightFeeTooltip />}
                price={copyrightFee}
                dataTest={ORDER_CART_TEST_ID.PRICE_GIFT_COPYRIGHT_FEE}
            />
        </GiftEntryListItem>
    );
};
